import React from 'react';
import PropTypes from 'prop-types';

import DataProvider from '../../HO/State/DataProvider';
import { Provider } from './TemplatesContext';

const TemplatesProvider = ({ children, form }) => (
  <DataProvider route="templates" Provider={Provider} form={form}>
    {children}
  </DataProvider>
);

TemplatesProvider.propTypes = {
  children: PropTypes.node.isRequired,
  form: PropTypes.instanceOf(Object),
};

TemplatesProvider.defaultProps = {
  form: null,
};

export default TemplatesProvider;
